import React from 'react'
import { CustomLink as Link } from '@the-platform-group/component-library'
import { IrwinAssistantSideDrawerContent } from '@the-platform-group/component-library/IrwinAssistant'
import { useDrawerContext } from '@the-platform-group/component-library/DrawerContext'
import { useFileDownload } from 'hooks/useFileDownload'

// Wrapper component to manage the download state within the drawer
const DrawerContentWrapper = ({ value, handleFileDownload, getBulkDownloadUrl }) => {
  const { download, isLoading } = useFileDownload()
  const bulkDownloadUrl = getBulkDownloadUrl(value.id)

  return (
    <IrwinAssistantSideDrawerContent
      files={value.filePaths || []}
      requestId={value.id}
      handleFileDownload={handleFileDownload}
      handleBulkDownload={download}
      bulkDownloadUrl={bulkDownloadUrl}
      isBulkDownloading={isLoading}
    />
  )
}

const FilesCell = ({ value, handleFileDownload, getBulkDownloadUrl }) => {
  const { setDrawerState } = useDrawerContext()

  return (
    <Link
      onClick={e => {
        e.preventDefault()
        setDrawerState({
          isOpen: true,
          title: `${value.name || ''} Files`,
          content: (
            <DrawerContentWrapper
              value={value}
              handleFileDownload={handleFileDownload}
              getBulkDownloadUrl={getBulkDownloadUrl}
            />
          ),
        })
      }}
    >
      {(() => {
        switch (value.filePaths?.length) {
          case undefined:
          case null:
          case 0:
            return '-'
          case 1:
            return '1 File'
          default:
            return `${value.filePaths?.length} Files`
        }
      })()}
    </Link>
  )
}

export default FilesCell
